export enum TrancheStatus {
    'Active' = 'Active',
    'Draft' = 'Draft',
    'Inactive' = 'Inactive',
}
